module.exports = "pegasus/assets/classic-twitter-old.png";